export default "__VITE_ASSET__7a88da21__"